import { Container } from "react-bootstrap";
import NavigationBar from "../Navbar/Navbar";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import Unauthorized from "../../pages/Auth/Unauthorized";
import { useGetData } from "../../hooks/useGetData";
import Loader from '../../component/Loader/Loader';
import React from "react";

interface AppLayoutProps {
    children: React.ReactNode;
}

const MainAppLayout = ({
    children
}: AppLayoutProps) => {
    const isAuthenticated = useIsAuthenticated();

    const { instance, accounts } = useMsal();
    const userEmail = accounts[0] && accounts[0].username;
    const url = 'UserSecurity/CheckUserByEmail/' + userEmail;
    const { getDataById: checkUserAccess } = useGetData<any, string>(url, "GET");
    const [userAccess, setUserAccess] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        // If not authenticated, we skip loading user permissions.
        // isLoading => false so we can show <Unauthorized /> right away.
        if (!isAuthenticated) {
          setIsLoading(false);
          return;
        }
    
        if (userEmail) {
          loadUserPermissions("");
        } else {
          setIsLoading(false);
        }
      }, [userEmail, isAuthenticated]);

      const loadUserPermissions = async (inputValue: string) => {
        try {
          setIsLoading(true);
          const response = await checkUserAccess(inputValue);
          setUserAccess(response);
        } catch (error) {
          console.error("Error checking user access:", error);
          setUserAccess(false);
        } finally {
          setIsLoading(false);
        }
      };

      return (
        <div>
          <header>
            <NavigationBar />
          </header>
          <main className="pb-2">
            {!isAuthenticated ? (
              <Unauthorized />
            ) : (
              isLoading ? (
                <div className="mt-4 text-center">
                  <Loader />
                </div>
              ) : userAccess ? (
                <Container fluid className="mt-4 px-5">{children}</Container>
              ) : (
                <Unauthorized />
              )
            )}
          </main>
        </div>
      );
    };
    

export default MainAppLayout;
